angular
  .module("myApp")
  .directive("info", () => {
    return {
      templateUrl: "directives/info.html",
      controller: "InfoController",
      scope: {
        key: "@",
      },
    };
  })

  .controller("InfoController", ($scope, Codifiers) => {
    $scope.kla = Codifiers.kla;
    console.log($scope.key)
  });
